export default __webpack_public_path__ + "static/media/marketplace-white.db5f9ae7.svg";